<template>
  <div class="supplier-products-page">
    <PageHeader
      title="Produits reçus"
      showBackIcon
      @back="$router.push({
        name: 'ChooseBonDeLivraison',
        params: { supplierId: supplierId }
      })" />
    <SearchBar
      placeholder="Recherchez par titre"
      @onQuery="searchQuery = $event"/>
    <div class="product-items-grid" v-loading="loading">
      <EmptyState v-if="!filteredProducts.length"/>
      <ProductItem
        style="margin: 5px"
        v-for="product in filteredProducts"
        :key="product.id"
        :product="product"
        @onClick="showProductDrawer(product)"
      />
    </div>
    <el-drawer
      title="I am the title"
      :visible.sync="showDrawer"
      direction="btt"
      :with-header="false">
      <DrawerQuantity
        v-if="showDrawer"
        @onCancel="showDrawer = false"
        @onValueSaved="handleProductQuantitySaved"
        :defaultQuantity="0"
      />
    </el-drawer>
  </div>
</template>

<script>
import ProductItem from '@/views/pages/SupplierProductsPage/ProductItem.vue';
import PageHeader from '@/components/PageHeader/PageHeader.vue';
import SearchBar from '@/components/SearchBar.vue';
import DrawerQuantity from '@/components/DrawerQuantity.vue';
import BDLProduct from '@/entities/BDLProduct';
import BonDeLivraison from '@/entities/BonDeLivraison';
import EmptyState from '@/components/EmptyState.vue';
import services from 'services';
import firebase from 'firebase';
import dayjs from 'dayjs';

export default {
  components: {
    ProductItem,
    PageHeader,
    SearchBar,
    DrawerQuantity,
    EmptyState,
  },
  props: {
    supplierId: { type: String, required: true },
    bonDeLivraisonId: { type: String, required: true },
  },
  async mounted() {
    this.loading = true;
    await this.fetchData();
    this.loading = false;
  },
  data() {
    return {
      loading: false,
      products: [],
      bdlProducts: [],
      searchQuery: '',
      selectedProduct: null,
      showDrawer: false,
    };
  },
  computed: {
    filteredProducts() {
      if (!this.searchQuery.length) {
        return this.mergedProducts;
      }
      return this.mergedProducts.filter((product) => {
        const queryLower = this.searchQuery.toLowerCase();
        const nameLower = product.name.toLowerCase();
        const codeSupplierLower = product.codeSupplier.toLowerCase();
        const matchName = nameLower.indexOf(queryLower) !== -1;
        const matchBEF = codeSupplierLower.indexOf(queryLower) !== -1;
        return matchName || matchBEF;
      });
    },
    mergedProducts() {
      return this.products.map((product) => ({
        ...product,
        ...this.bdlProducts.find((e) => e.codeSupplier === product.codeSupplier),
      }));
    },
  },
  methods: {
    async fetchData() {
      const shopId = this.$store.getters['shopAuth/currentShopId'];
      const p1 = services.productService.listBySupplierAndShopId(this.supplierId, shopId);
      const p2 = services.bdlService.listProducts(this.bonDeLivraisonId);
      const [products, bdlProducts] = await Promise.all([p1, p2]);
      this.products = products;
      this.bdlProducts = bdlProducts;
    },
    showProductDrawer(product) {
      this.showDrawer = true;
      this.selectedProduct = product;
    },
    async handleProductQuantitySaved(quantity) {
      const bdlProduct = new BDLProduct({
        ...this.selectedProduct,
        id: this.selectedProduct.codeSupplier,
        bonDeLivraisonId: this.bonDeLivraisonId,
        shopId: this.$store.getters['shopAuth/currentShopId'],
        quantity,
        status: BDLProduct.statusTypes.delivered,
      });
      await services.bdlService.upsertProductById(this.selectedProduct.codeSupplier, {
        ...bdlProduct,
        deliveredAt: firebase.firestore.FieldValue.serverTimestamp(),
        deliveredAtDayString: dayjs().format('DD-MM-YYYY'),
      });
      await services.bdlService.updateById(this.bonDeLivraisonId, {
        status: BonDeLivraison.statusTypes.delivered,
        deliveredAt: firebase.firestore.FieldValue.serverTimestamp(),
        deliveredAtDayString: dayjs().format('DD-MM-YYYY'),
      });
      await this.fetchData();
      this.$message.success({
        message: 'Quantité enregistrée',
      });
      this.selectedProduct = null;
    },
  },
};
</script>

<style lang="stylus">
@import '../../../assets/css/main.styl';

.el-message {
  min-width: 90%;
}

.product-items-grid {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 20px;
}

.product-items-grid::after {
  content: '';
  flex: auto;
}

.supplier-products-page {
  width: 100%;
}
.supplier-products-card {
  width: 90%;
  margin-top: 0px;
  margin-bottom: 0px;
  overflow-x: hidden;
  border-radius: 0;
}

.shop-users-title {
  color: $primary-color;
  position: relative;
  font-size: 2.3em;
  font-weight: 600;
  display: inline;
}
.supplier-products-card__login-form {
}

</style>
